import { observer } from "mobx-react"
import React, { useRef, useState, useEffect, useCallback } from "react"
import currentExpensesJson from "../../../Configs/JSON/currentExpenses.json"
import "../../../styles/Calculator/AccurateResult.less"
import CalculatorStore from "../../../Configs/Store/calculator"
import { addCommas } from "../../Common/CommonFunctions"

const DEBOUNCE_DELAY = 250

const handleExpensesKeypress = (event) => CalculatorStore.setCurrentChar(event.key)

const storeValueFor = (index) => {
  switch (index) {
    case 0:
      return CalculatorStore.accurateResultValueHouse
    case 1:
      return CalculatorStore.accurateResultValueFood
    case 2:
      return CalculatorStore.accurateResultValueTransport
    case 3:
      return CalculatorStore.accurateResultValueEntertainment
    case 4:
      return CalculatorStore.accurateResultValueMiscellaneous
    default:
      return 0
  }
}

const AccurateField = observer(function AccurateField({ index, heading, showFooter, onCommit }) {
  const inputRef = useRef(null)
  const debounceTimer = useRef(null)
  const editing = useRef(false)
  const storeValue = storeValueFor(index)
  const [displayValue, setDisplayValue] = useState(storeValue)

  useEffect(() => {
    if (!editing.current) {
      setDisplayValue(storeValue)
    }
  }, [storeValue])

  useEffect(() => {
    return () => {
      if (debounceTimer.current !== null) {
        clearTimeout(debounceTimer.current)
      }
    }
  }, [])

  const handleChange = (e) => {
    const digits = e.target.value.replace(/[^0-9]/g, "").replace(/^0+(?=\d)/, "")
    setDisplayValue(digits)
    if (debounceTimer.current !== null) {
      clearTimeout(debounceTimer.current)
    }
    debounceTimer.current = setTimeout(() => {
      debounceTimer.current = null
      onCommit(index, digits)
    }, DEBOUNCE_DELAY)
  }

  const handleFocus = () => {
    editing.current = true
  }

  const handleBlur = () => {
    editing.current = false
    if (debounceTimer.current !== null) {
      clearTimeout(debounceTimer.current)
      debounceTimer.current = null
    }
    const formatted = onCommit(index, displayValue)
    if (formatted !== undefined && formatted !== null) {
      setDisplayValue(formatted)
    }
  }

  return (
    <div className="form-group col-xl-4 col-lg-6">
      <label htmlFor={"accurateResult" + index}>{heading}</label>
      <div className="custom-input-group custom-input-group-sm input-group" id={index}>
        <div className="input-group-prepend" id="inputGroupPrepend">
          {" "}
          <span className="input-group-text">₹</span>{" "}
        </div>
        <input
          className="form-control"
          id={"accurateResult" + index}
          type="tel"
          pattern="[0-9]*"
          name="accurateResultValue"
          value={displayValue}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={handleFocus}
          ref={inputRef}
          autoFocus={inputRef.current === document.activeElement}
          onKeyPress={handleExpensesKeypress}
        />
      </div>
      {showFooter && <div className="footerTextPF"> (non-taxable upto 2.5 L p.a.) </div>}
    </div>
  )
})

const AccurateResult = (props) => {
  const { scrn, handlecurrentExpenses_Accurate } = props

  const handlerRef = useRef(handlecurrentExpenses_Accurate)
  useEffect(() => {
    handlerRef.current = handlecurrentExpenses_Accurate
  }, [handlecurrentExpenses_Accurate])

  const commitAccurate = useCallback((index, value) => {
    const handler = handlerRef.current
    if (typeof handler === "function") {
      handler({ target: { id: "accurateResult" + index, value } }, index)
      return storeValueFor(index)
    }
    return addCommas(value === "" ? 0 : value)
  }, [])

  const activeEntry = currentExpensesJson.find((data) => data.id === scrn)
  if (!activeEntry) {
    return null
  }

  return (
    <>
      {activeEntry.accurateResult.map((d) => (
        <AccurateField key={d.id} index={d.id} heading={d.accurateResultHeading} showFooter={scrn === "Scr5" && d.id === 3} onCommit={commitAccurate} />
      ))}
    </>
  )
}

export default AccurateResult
